module.exports = __webpack_public_path__ + "static/media/product1.309543d4.png";